<template>
	<div class="name-form">
		<h2>{{ $t('base.profile.change_name') }}</h2>
		<spinner v-if="model.loading"/>
		<form v-if="!model.loading && model.hasData()" @submit.prevent="validateAndSubmit">
			<input-text v-model="model.data.fullname" name="user_fullname" :placeholder="$t('labels.profile.new_name')" rules="required"/>
			<error-box v-if="form.error" :error="form.error"/>
			<button-submit :loading="form.loading">{{ $t('buttons.actions.update_name') }}</button-submit>
		</form>
		<!--pre>{{ model }}</pre-->
	</div>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
import FormObject from '@/classes/api/FormObject'
export default {
	props: [
		'user_uid'
	],
	data () {
		return {
			model: new ApiObject(),
			form: new FormObject()
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.editUser()
				})
		},
		getUser () {
			this.model.loading = true
			this.$api.users.getByUid(this, this.user_uid)
				.then(response => {
					this.$log.info('account information', 'users.getByUid OK', response)()
					this.model.data = response.body
				})
				.catch(error => {
					this.$log.error('account information', 'users.getByUid ERROR', error)()
					this.model.error = error
				})
				.finally(() => {
					this.model.loading = false
				})
		},
		editUser () {
			this.form.loading = true
			this.form.error = null
			this.$api.users.edit(this, this.user_uid, this.model.data)
				.then(response => {
					this.$log.info('user profile', 'users.edit OK', response)()
					this.$root.$emit('add-floating-box', { title: 'Success', text: 'Name updated.' })
				})
				.catch(error => {
					this.$log.error('user profile', 'users.edit ERROR', error)()
					this.form.error = error
				})
				.finally(() => {
					this.form.loading = false
					this.$store.dispatch('getUser', { context: this })
				})
		}
	},
	mounted () {
		this.getUser()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/accountinformation/NameForm.vue